// Constants
export const datos_afiliado = () => {
    return {
        datos_afiliado: {
            id: {
                namepath: ['servicios_registrar', 'afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'afiliacion_servicios', 'aportes_pendientes'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                readonly: true,
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: null,
                }
            },
            id_list_documento: {
                type: "text",
                label: "Tipo Doc",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_documento",
                    label: 'name',
                    minform: true,
                }
            },
            id_list_estado: {
                type: "text",
                label: "Estado",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_estado",
                    label: 'name'
                }
            },
            name: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'facturacion_descargas', 'facturacion_descargarafl', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            documento: {
                type: "number",
                label: "Documento",
                placeholder: "",
                namepath: ['servicios_registrar', 'admin_precios', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros', 'afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'facturacion_descargas', 'facturacion_descargarafl', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    prepend: '',
                    append: '',
                    predeterminate: '',
                    minform: true
                }
            },
            nombre1: {
                type: "text",
                label: "1° Nombre",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                    minform: true
                }
            },
            nombre2: {
                type: "text",
                label: "2° Nombre",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                    minform: true
                }
            },
            apellido1: {
                type: "text",
                label: "1° Apellido",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                    minform: true
                }
            },
            apellido2: {
                type: "text",
                label: "2° apellido",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                    minform: true
                }
            },
            direccion: {
                type: "text",
                label: "Direccion",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'aportes_cuentas', 'archivo_retiros', 'aportes_registrar', 'servicios_aportes', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                    minform: true
                }
            },
            ciudad: {
                type: "text",
                label: "Ciudad",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'aportes_cuentas', 'archivo_retiros', 'aportes_registrar', 'servicios_aportes', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            email: {
                type: "text",
                label: "Correo",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "email",
                    disabled: false,
                    predeterminate: null,
                }
            },
            telefonos: {
                type: "text",
                label: "Telefonos",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'aportes_cuentas', 'archivo_retiros', 'aportes_registrar', 'servicios_aportes', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes', 'aportes_pendientes'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                    minform: true
                }
            },
            nacimiento: {
                type: "date",
                label: "Fecha de Nacimiento",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            servicios: {
                type: "boolean",
                label: "Solo servicios",
                placeholder: "",
                namepath: ['servicios_afiliacion'],
                description: "",
                validate: "",
                datatype: {
                    type: "check",
                    disabled: false,
                    predeterminate: 0,
                }
            },
            referido: {
                type: "text",
                label: "Referido por",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'informes_afiliaciones', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "multiselect",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_afiliado",
                    label: 'name'
                }
            },
            planilla: {
                type: "boolean",
                label: "Solicita planilla",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'aportes_cuentas', 'archivo_retiros', 'informes_afiliaciones', 'aportes_registrar', 'servicios_aportes', 'afiliado_nomina', 'afiliado_ficha', 'afiliacion_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "check",
                    disabled: false,
                    predeterminate: 0,
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
        }
    }
}